<script>
  import Icon from "../Icon.svelte";

  export let pagination = {};
  export let removeSpacing = false;
  let offsetStart;
  let offsetEnd;
  let hasPreviousPage;
  let hasNextPage;

  $: {
    offsetStart = pagination.perPage * (pagination.page - 1) + 1;
    offsetEnd = offsetStart + pagination.perPage - 1;

    if (offsetEnd > pagination.totalEntries) {
      offsetEnd = pagination.totalEntries;
    }
  }

  function nextPage() {
    if (!hasNextPage) {
      return;
    }
    var newPage = pagination.page + 1;
    pagination.goToPage(newPage);
  }

  function previousPage() {
    if (!hasPreviousPage) {
      return;
    }
    var newPage = pagination.page - 1;

    pagination.goToPage(newPage);
  }

  $: {
    hasPreviousPage = pagination && pagination.page > 1;
    hasNextPage = pagination && offsetStart + pagination.perPage <= pagination.totalEntries;
  }

</script>

<span
  class={removeSpacing ? "pagination-wrapper" : "pagination-wrapper padding--small margin--small"}
>
  {#if offsetStart}
    <span class="margin-right--smaller">
      <span class="w700" data-testid="page-offset">{offsetStart}-{offsetEnd}</span>
      {#if pagination.showTotals != false}
        <span>
          of
          <span class="w700" data-testid="total-entries">{pagination.totalEntries}</span>
        </span>
      {/if}
    </span>
  {/if}

  <button
    aria-label="pagination-back"
    class="button button--primary-flat button--pagination previous-page"
    on:click={previousPage}
    disabled={!hasPreviousPage}
  >
    <Icon width="14" height="14" type="ArrowLeft" />
  </button>
  <button
    aria-label="pagination-forward"
    class="margin-left--smallest button button--primary-flat button--pagination next-page"
    on:click={nextPage}
    disabled={!hasNextPage}
  >
    <Icon width="14" height="14" type="ArrowRight" />
  </button>
</span>
